import OverviewZone from 'components/Catalog/ProductGrid/CompareModal/Zones/OverviewZone/OverviewZone';

export default OverviewZone;
